import Grid, { GridSpacing } from "@mui/material/Grid";
import { ComponentProps } from "../types";
import DashboardComponent from "./DashboardComponent";
import { CSSProperties, useContext, useMemo } from "react";
import ExecutionTypeContext, { Mode } from "../ExecutionTypeContext";
import DashboardPageContext from "../DashboardPageContext";

function Component({ component }: ComponentProps) {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { context, params, updateContext } = useContext(DashboardPageContext);
	const exeMode = useContext(ExecutionTypeContext);
	const style = useMemo(() => {
		const style = {} as CSSProperties;
		if (exeMode?.mode === Mode.DESIGN && component.id === exeMode?.activeComponent?.id) style.border = "1px dashed red";
		return style;
	}, [component, exeMode]);
	const args = useMemo(() => {
		const args = {} as { [key: string]: unknown };
		if (exeMode?.mode === Mode.DESIGN && exeMode.locatorActivated === true) {
			args["onClick"] = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
				if (exeMode.updateActiveComponent) exeMode.updateActiveComponent(component);
				event.stopPropagation();
			};
		}
		return args;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [component, context, exeMode]);
	return (
		<Grid container spacing={parseInt(component.properties["spacing"] || "0") as GridSpacing} style={style} sx={exeMode?.mode === Mode.DESIGN && component.id === exeMode?.activeComponent?.id ? { "& > .MuiGrid-item": { border: "1px dashed red" } } : {}} {...args}>
			{component.childern && component.childern.map((c, i) => <DashboardComponent key={i} component={c} />)}
		</Grid>
	);
}

export default Component;
